import ReactDOM from 'react-dom/client';
import { ToastContainer } from 'react-toastify';
import { TenantContext } from '../../../../context/tenant-context';
import { v2Component } from '../../../..';
import { ProductDeliveryConfigForm } from './product-delivery-config';

export function initProductDeliveryConfig(element?: HTMLElement) {
  const elements = element !== undefined ? [element] : document.getElementsByName('product-delivery-config-form');

  elements.forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');
      const root = ReactDOM.createRoot(element);

      const bootstrap = () => {
        const { tenant, contextPath, productId } = Object.assign({}, element.dataset) as any;
        root.render(
          v2Component(
            <TenantContext.Provider value={{ tenant, contextPath, spaMode: false }}>
              <ToastContainer />
              <ProductDeliveryConfigForm productId={productId} />
            </TenantContext.Provider>,
          ),
        );
      };

      bootstrap();
    }
  });
}
